import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { CostReportItem } from './types';

interface State {
    filter: {
        searchValue: string;
    },
    data: Array<CostReportItem>
}

const initialState: State = {
    filter: {
        searchValue: '',
    },
    data: []
}

const costReportSlice = createSlice({
    name: 'costReport',
    initialState,
    reducers: {
        clearData: (state) => {
            state.data = []
        },
        setData: (state, action: PayloadAction<Array<CostReportItem>>) => {
            state.data = action.payload
        },
        updateSearchValue: (state, action: PayloadAction<string>) => {
            state.filter.searchValue = action.payload;
        }
    }
})

export const { updateSearchValue, clearData, setData } = costReportSlice.actions;

export default costReportSlice.reducer;
